export default "__VITE_ASSET__5491ea7b__"